<div class="row">
  <div class="col">
    <div class="text-lg-right pt-2 ca-toolbar" id="AbpContentToolbar">
      <div class="ca-toolbar-east-section">
        <div class="toolbar-item">
          <button
            class="btn ca-btn ca-btn-neutral-toolbar toolbar-button"
            type="button"
            (click)="newLLMConfiguration()">
            <i class="far fa-plus-circle"></i>
            <span>{{ 'Settings::LLMConfiguration:NewLLMConfiguration' | abpLocalization }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
